import {RouteProp, useRoute} from '@react-navigation/native';
import React from 'react';
import AppleLogin from 'react-apple-login';

import {Button} from '../../../../components/Button';
import {Environment} from '../../../../constants';
import {AppleIcon} from '../../../../icons';
import {RedirectOptions} from '../../../../navigators/params';
import {colors} from '../../../../styles';
import {
  createSocialAuthState,
  getSocialAuthCallback,
} from '../../../../util/url';
import {authStyles} from '../../styles';
import {SocialAuthButtonProps} from './AppleSignIn';

export const AppleSignIn: React.FC<SocialAuthButtonProps> = ({
  disabled,
  screen,
}) => {
  const route =
    useRoute<RouteProp<{[x: string]: {redirect?: RedirectOptions}}>>();

  const redirect = route.params?.redirect;

  const [clicked, setClicked] = React.useState<boolean>(false);

  //Set clicked state back to false after 3 seconds
  React.useEffect(() => {
    if (!clicked) return;

    setTimeout(() => setClicked(false), 3000);
  }, [clicked, setClicked]);

  return (
    <AppleLogin
      clientId={Environment.apple.clientId}
      redirectURI={getSocialAuthCallback('apple')}
      scope="email name"
      responseMode="form_post"
      responseType="code"
      state={createSocialAuthState({state: screen, redirect})}
      render={props => (
        <Button
          style={authStyles.socialButton}
          disabled={clicked || props.disabled || disabled}
          onPress={() => {
            setClicked(true);
            props.onClick();
          }}
          {...props}>
          <AppleIcon color={colors.black} solid />
        </Button>
      )}
    />
  );
};
